<template>
    <div class="card pay-status">
        <div class="card-body">
            <h5 class="text-center">
                {{ 'checkout.pay.pleaseWait' | trans }}
            </h5>

            <svg class="loader" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg" v-if="isLoading">
                <circle class="internal-circle" cx="60" cy="60" r="30"></circle>
                <circle class="external-circle" cx="60" cy="60" r="50"></circle>
            </svg>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['stripeKey', 'paymentIntentId', 'paymentIntentClientSecret', 'sourceId', 'sourceClientSecret', 'successUrl', 'cancelUrl'],
        data() {
            return {
                isLoading: true,
                stripe: null,
                max: 20,
                count: 0,
            }
        },
        mounted() {
            // Include Stripe SDK
            let stripeScript = document.createElement('script')
            stripeScript.onload = this.initStripe
            stripeScript.setAttribute('src', 'https://js.stripe.com/v3/')
            document.head.appendChild(stripeScript)
        },
        computed: {},
        methods: {
            async fetchStatus() {
                // Handle source object
                if (this.sourceId) {
                    const { source } = await this.stripe.retrieveSource({
                        id: this.sourceId,
                        client_secret: this.sourceClientSecret,
                    })

                    if (source.status === 'chargeable') {
                        window.location.href = this.successUrl
                    } else if (source.status === 'pending' && this.count < this.max) {
                        this.count += 1;
                        setTimeout(this.fetchStatus, 1000);
                    } else {
                        window.location.href = this.cancelUrl
                    }
                }

                // Handle payment intent object
                if (this.paymentIntentId) {
                    const { paymentIntent } = await this.stripe.retrievePaymentIntent(this.paymentIntentClientSecret)

                    if (paymentIntent.status === 'succeeded') {
                        window.location.href = this.successUrl
                    } else if ((paymentIntent.status === 'processing' || paymentIntent.status === 'amount_capturable_updated') && this.count < this.max) {
                        this.count += 1;
                        setTimeout(this.fetchStatus, 1000);
                    } else {
                        window.location.href = this.cancelUrl
                    }
                }
            },
            initStripe() {
                this.stripe = Stripe(this.stripeKey);

                this.fetchStatus()
            }
        },
        watch: {}
    }
</script>
